import { Loader2 } from "lucide-react";
import { QaydMark } from "components/Brand";

/** Content-area loader: a thin accent spinner. */
export const CircleLoading = () => (
  <div className="relative block h-[calc(100vh-210px)] min-h-[380px]">
    <div className="absolute top-1/2 left-1/2 flex -translate-x-1/2 -translate-y-1/2 flex-col items-center gap-3">
      <Loader2 className="size-7 animate-spin text-accent" />
      <span className="text-[12.5px] text-faint">Loading…</span>
    </div>
  </div>
);

/** Full-screen app loader: the Qayd mark with a spinner ring. */
export const PreLoading = () => (
  <div className="absolute top-1/2 left-1/2 grid -translate-x-1/2 -translate-y-1/2 place-items-center">
    <span className="col-start-1 row-start-1 size-[76px] animate-spin rounded-full border-2 border-accent/15 border-t-accent" />
    <span className="col-start-1 row-start-1 animate-pulse">
      <QaydMark size={40} />
    </span>
  </div>
);
